import {getBestContrastHexColor} from "@spoferan/spoferan-ts-core";

export default {

    props: {
        color: {
            default: null
        },

        // Whether the color shall be inverted
        // Only works when a hex color is specified
        invertedColor: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        colorString() {
            return this.getColorString(this.color);
        },

        colorHex() {
            return this.getColorHex(this.color);
        },

        /**
         * A color modifier can be extracted with the color string that will be extracted here, e.g., '#34456 lighten'
         *
         * @returns {string|null}
         */
        colorModifierClass() {
            const colorModifier = ['lighten', 'darken'];
            let modifierClass = null;
            colorModifier.forEach(modifier => {
                if (this.color && this.color.includes(modifier)) {
                    modifierClass = modifier;
                }
            })

            return modifierClass
        }
    },

    methods: {
        getColorString(color) {
            if (color && !color.startsWith('#') && !color.startsWith('rgb')) {
                let colorName = color.split(' ')[0]; // In case a modifier is specified
                switch (colorName) {
                    case 'danger':
                        colorName = 'error';
                        break;
                }
                return colorName;
            }

            return null;
        },

        getColorHex(color) {
            if (color && (color.startsWith('#') || color.startsWith('rgb'))) {
                if (color.startsWith('#') && this.invertedColor) {
                    return getBestContrastHexColor(color.split(' ')[0]);
                }
                return color.split(' ')[0]; // In case a modifier is specified
            }

            return null;
        }
    }
}
